import queries from './queries';

const getNumberId = (id) => (typeof id === 'string' ? Number(id) : id);

export const roomQueryKeys = (roomId) => {
  const id = getNumberId(roomId);

  return [queries.room, id];
};

export const facilityMetersKeys = ({
  facilityId,
  officeId,
  searchString,
  typeId,
}) => {
  const facId = getNumberId(facilityId);
  const ofId = getNumberId(officeId);
  const tId = getNumberId(typeId);

  return [queries.facilityMeters, facId, ofId, searchString, tId];
};
